import { Injectable } from "@angular/core";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class DisabiliyTypesService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "disabilitytypes/";
  }

  add(body: any) {
    return this.post<any>({ APIName: "add", body, showAlert: true });
  }

  update(body: any) {
    return this.put<any>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<any>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<any>({ APIName: `getedit/${id}` });
  }

  getPaged(body: GetPagedBody<any>) {
    return this.getPagedRequest<any[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<any[]>({ APIName: "getall" });
  }
}
